module.exports = __webpack_public_path__ + "img/TX.f1ccdfa6.png";